import { render, staticRenderFns } from "./shop3.vue?vue&type=template&id=721b4af8&"
import script from "./shop3.vue?vue&type=script&lang=js&"
export * from "./shop3.vue?vue&type=script&lang=js&"
import style0 from "./shop3.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports